import { PELOTON_PLATFORM } from '@webtv/env';
import { getLgDevice } from './lg';
import { DEFAULT_DEVICE } from './models';
import { getSamsungDevice } from './samsung';
import { getSkyDevice } from './sky';
export var getDevice = function getDevice() {
  if (typeof window === 'undefined') {
    return DEFAULT_DEVICE;
  } else if (PELOTON_PLATFORM === 'sky_tv') {
    return getSkyDevice();
  } else if (PELOTON_PLATFORM === 'lg') {
    return getLgDevice();
  } else if (PELOTON_PLATFORM === 'samsung') {
    return getSamsungDevice();
  }

  return DEFAULT_DEVICE;
};
export function hasCapability(capability) {
  var _getDevice, _getDevice$capabiliti;

  var setting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return ((_getDevice = getDevice()) === null || _getDevice === void 0 ? void 0 : (_getDevice$capabiliti = _getDevice.capabilities) === null || _getDevice$capabiliti === void 0 ? void 0 : _getDevice$capabiliti[capability]) === setting;
}